"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _react = _interopRequireWildcard(require("react"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _emotion = require("emotion");

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _Icon = _interopRequireDefault(require("@cimpress/react-components/lib/Icon"));

var buttonTextStyle = (0, _emotion.css)({
  marginBottom: '0'
});
var buttonTitleStyle = (0, _emotion.css)({
  color: colors.ocean.base,
  fontSize: '20px',
  fontWeight: 300,
  marginBottom: '16px',
  marginTop: '0'
});
var divStyle = (0, _emotion.css)({
  display: 'flex'
});
var buttonStyle = (0, _emotion.css)({
  width: '500px'
});
var iconStyle = (0, _emotion.css)({
  alignSelf: 'center'
});

var RadioSelectorButton =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(RadioSelectorButton, _PureComponent);

  function RadioSelectorButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, RadioSelectorButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RadioSelectorButton).call(this, props));
    (0, _reactAutobind.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  (0, _createClass2.default)(RadioSelectorButton, [{
    key: "onClick",
    value: function onClick() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          value = _this$props.value;
      onClick(value);
    }
  }, {
    key: "getInnerButtonStyle",
    value: function getInnerButtonStyle() {
      return (0, _emotion.css)({
        background: "".concat(this.getBackgroundColor()),
        border: "1px solid ".concat(this.getBorderColor()),
        display: 'block',
        margin: '-1px 0 0',
        outline: 'none',
        padding: '27px 47px 33px',
        position: 'relative',
        zIndex: "".concat(this.getZIndex()),
        '&:first-child': {
          borderRadius: '4px 4px 0 0'
        },
        '&:last-child': {
          borderRadius: '0 0 4px 4px'
        },
        '&:active, &.active, &:hover': {
          border: "1px solid ".concat(colors.ocean.base),
          textDecoration: 'none',
          zIndex: 10
        },
        '&:active, &.active': {
          background: "".concat(colors.horizon)
        },
        textAlign: 'center',
        width: "".concat(this.getWidth())
      });
    }
  }, {
    key: "getBackgroundColor",
    value: function getBackgroundColor() {
      var selected = this.props.selected;
      return selected ? colors.horizon : colors.white;
    }
  }, {
    key: "getBorderColor",
    value: function getBorderColor() {
      var selected = this.props.selected;
      return selected ? colors.ocean.base : colors.platinum;
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      var displayCheckmark = this.props.displayCheckmark;
      return displayCheckmark ? '95%' : '100%';
    }
  }, {
    key: "getZIndex",
    value: function getZIndex() {
      var selected = this.props.selected;
      return selected ? 10 : 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          description = _this$props2.description,
          displayCheckmark = _this$props2.displayCheckmark,
          selected = _this$props2.selected,
          style = _this$props2.style,
          title = _this$props2.title;

      var checkmark = displayCheckmark && selected && _react.default.createElement("div", {
        className: iconStyle
      }, _react.default.createElement(_Icon.default, {
        color: colors.teal.base,
        name: "check-circle-2-f",
        size: "2x"
      }));

      var outerButtonStyle = !style ? buttonStyle : style;
      return _react.default.createElement("div", {
        className: divStyle
      }, _react.default.createElement("div", {
        className: outerButtonStyle
      }, _react.default.createElement("button", {
        className: this.getInnerButtonStyle(),
        onClick: this.onClick
      }, _react.default.createElement("h3", {
        className: buttonTitleStyle
      }, title), _react.default.createElement("p", {
        className: buttonTextStyle
      }, description))), checkmark);
    }
  }]);
  return RadioSelectorButton;
}(_react.PureComponent);

var _default = RadioSelectorButton;
exports.default = _default;